export const APPLY_STATUS = {
  ACTIVE: 'active',
  CANCELLED: 'cancelled',
  REJECTED: 'rejected',
  SUBMITTED: 'submitted',
};

export const MILESTONES = [
  { bonus: 0, referrals: 1 },
  { bonus: 50, referrals: 5 },
  { bonus: 100, referrals: 10 },
  { bonus: 200, referrals: 20 },
  { bonus: 300, referrals: 30 },
  { bonus: 400, referrals: 40 },
  { bonus: 500, referrals: 50 },
];

export const PAYOUT_STATUS = {
  AWAITING_UPGRADE: 'awaiting_upgrade',
  PAID: 'paid',
  PENDING_PAYOUT: 'pending_payout',
};

export const SURVEY_FORM_DATA = {
  is_active_ecommerce_seller: true,
  sales_channels: {
    etsy: false,
    amazon: false,
    ebay: false,
    faire: false,
    shopify: false,
    squarespace: false,
    woocommerce: false,
    tiktok: false,
    facebook: false,
    other_enabled: true,
    other: '',
  },
  seller_categories: {
    run_own_ecommerce_business: false,
    manage_businesses_for_others: false,
    influencer_creator_educator: false,
    other_enabled: true,
    other: '',
  },
  social_accounts: {
    facebook: '',
    instagram: '',
    tiktok: '',
    youtube: '',
    pinterest: '',
    other: '',
  },
  content_sources: '',
  affiliate_companies: '',
  affiliate_support_needs: '',
};
